export { TextInput, } from "./TextInput";
export { InputGroup, } from "./InputGroup";
export { Select, } from "./Select";
export { Button, ButtonColor, ButtonStyle, } from "./Button";
export { ButtonGroup, } from "./ButtonGroup";
export { Checkbox, } from "./Checkbox";
export { NumberInput, } from "./NumberInput";
export { SelectInput, SelectInputMode, } from "./SelectInput";
export { TextArea, } from "./TextArea";
export { Modal, ModalType, } from "./Modal";
export { Dropdown, } from "./Dropdown";
export { SplitButton, } from "./SplitButton";
export { Collapsible, } from "./Collapsible";

// export props aliases
export type { ButtonProps } from "./Button";
export type { DropdownProps } from "./Dropdown";

// classNames utility function
export const classNames = (classes: (string | null | boolean)[]): string => {
    const css = classes.filter(value => !(value == null || value === "" || !value));
    return css.join(" ").trim();
};

export const parseClasses = (classes: string | string[] | undefined): string => {
    if (!classes) {
        return "";
    }

    const css = classes ? (Array.isArray(classes) ? [...classes].join(" ") : classes) : "";
    return css;
};

// colors & styles
export enum FormControlStyle {
    Primary = "Primary",
    Secondary = "Secondary",
    Success = "Success",
    Danger = "Danger",
    Warning = 'Warning',
    Info = "Info",
    Light = "Light",
    Dark = "Dark",
    Inline = "Inline",
    Badge = "Badge",
    Link = "Link",
    Custom = "Custom",
    None = "None",
};

export enum FormControlColor {
    Primary = "Primary",
    Secondary = "Secondary",
    Success = "Success",
    Danger = "Danger",
    Warning = 'Warning',
    Info = "Info",
    Light = "Light",
    Dark = "Dark",
};

export enum FormControlSize {
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
};

export const getFormStyleSuffix = (style: FormControlStyle): string => {
    return style.toString().toLowerCase();
};

export const getFormSizeSuffix = (size: FormControlSize): string => {
    switch (size) {
        case FormControlSize.Small:
            return "sm";

        case FormControlSize.Large:
            return "lg";
    }

    return "";
};

